import { useContext } from "react";
import { Container } from "react-bootstrap";
import { AuthContext } from "../../../contexts/Authentication/AuthContext";
import AddNewPage from "./AddNewPage";
import Pages from "./Pages";
import "./styles.css";
import { HomeProvider } from "../../../contexts/Home/HomeContext";

const UserPages = ({ newPage }: { newPage?: boolean }) => {
  const { isAuthenticated, hasShortToken } = useContext(AuthContext);

  return (
    <HomeProvider>
      <Container className="overflow-hidden">
        <div className="cards-pages">
          {isAuthenticated ? (
            <AddNewPage modal={true} modalAddPageShow={newPage ?? false} />
          ) : (
            <></>
          )}
          {isAuthenticated || hasShortToken ? <Pages /> : <></>}
        </div>
      </Container>
    </HomeProvider>
  );
};

export default UserPages;
